<div
  *ngIf="
    context.flag &&
    context.activeTab === 'invoice-expired' &&
    context.showExpiredInvoices
  "
  style="overflow: hidden"
>
  <p *ngIf="!context.tableData.length" class="m-0">No data found</p>
  <table
    datatable
    [dtOptions]="context.expiredInvoicesDtOptions"
    class="row-border hover m-0 w-100"
  >
    <thead>
      <tr>
        <th *ngFor="let thead of context.expiredInvoicesTheads">{{ thead }}</th>
      </tr>
    </thead>
    <tbody></tbody>
  </table>
</div>
